import validate from "D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher_e50bcd92f9fdbb4bc71ed87e93b8b1c9/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher_e50bcd92f9fdbb4bc71ed87e93b8b1c9/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}